import React from "react";
import styles from "./ImageGrid.module.scss";
import { ImageGridOptionsType } from "@/types/ModuleOptionsType";
import * as motion from "motion/react-m";
import { stagger_variant } from "../../utils/animation/transitions";

import { Modul_Bild_Grid_Download_Grid } from "../../wp/types/acf-module-types";
import { Section } from "../../components/Global/Section/Section";
import { Headline } from "../../components/Global/Headline/Headline";
import ImageGridCard from "./ImageGridCard";
import {
  Grid,
  GridContent,
  GridItem,
} from "@aleksundshantu.com/aunds-utils-react/primitives/grid";
import { useSublinesVisibility } from "../../hooks/useSublinesOverlinesVisibility";
import { checkModuleIsHidden } from "@/utils/checkModuleIsHidden";

export type ImageGridType = Modul_Bild_Grid_Download_Grid;

interface ImageGridProps {
  data: ImageGridType;
  imageGridOptions: ImageGridOptionsType;
}

const ImageGridModule = ({ data, imageGridOptions }: ImageGridProps) => {
  const {
    section_padding_class,
    section_margin_class,
    background_color_class,
    id,
    headline_text_align_class,
    grid_columns: max_images,
  } = data.layout;

  const {
    show_overline_subline,
    button_type,
    box: { show_border_radius, show_box_shadow, show_card_box },
    show_extended_link,
    media_format,
    grid_options: { text_align_class },
  } = imageGridOptions;

  const {
    headline,
    headline_html_tag,
    subline,
    overline,
    elements,
    type,
    grid_type,
  } = data.image_grid;
  const itemWidth = {
    mobile: "100%",
    tablet: "50%",
    desktop: "33.33%",
    fullhd:
      max_images === "three-cols"
        ? "33.33%"
        : max_images === "four-cols"
          ? "25%"
          : "20%",
  };
  // const posts_per_page =
  //   max_images === "three-cols" ? 6 : max_images === "four-cols" ? 8 : 10;
  const posts_per_page = 12; // https://trello.com/c/84kAYpBf/107-downloadgrid-modul

  const { showOverline, showSubline } = useSublinesVisibility(
    show_overline_subline,
  );

  const overline_subline = showOverline ? overline : showSubline ? subline : "";

  {
    /* jscpd:ignore-start */
  }
  //! check if module is hidden
  const isHidden = checkModuleIsHidden(data.settings);
  if (isHidden) {
    return null;
  }
  {
    /* jscpd:ignore-end */
  }

  return (
    <Section
      id={id}
      className={`image-grid ${styles["image-grid"]}  ${background_color_class} ${section_padding_class} ${section_margin_class}`}
      disableColumns
    >
      <motion.div
        variants={stagger_variant}
        initial="initial"
        whileInView={"animate"}
        viewport={{ once: true, amount: 0.3 }}
        className="columns is-multiline is-centered"
      >
        {(headline || overline_subline) && (
          <div className="column is-12">
            <Headline
              headline_html_tag={headline_html_tag}
              headline={headline}
              extraClass={headline_text_align_class}
              overline={showOverline ? overline_subline : ""}
              subline={showSubline ? overline_subline : ""}
              syncAnimation
            />
          </div>
        )}
        <div className="column is-12 ">
          <Grid
            postsPerPage={posts_per_page}
            fetchItems={() => {
              return {
                posts: elements ? elements : [],
                totalPosts: elements ? elements.length : 0,
              };
            }}
            showAllPages
          >
            {(elements) => {
              return (
                <>
                  <GridContent gap="2rem">
                    {elements.map((element, key) => {
                      return (
                        <GridItem itemWidth={itemWidth} key={key}>
                          <ImageGridCard
                            buttonType={button_type}
                            type={type}
                            element={element}
                            gridType={grid_type}
                            textAlignClass={text_align_class}
                            showExtendedLink={show_extended_link}
                            mediaFormat={media_format}
                            showBorderRadius={show_border_radius}
                            showBoxShadow={show_box_shadow}
                            showBox={show_card_box}
                          />
                        </GridItem>
                      );
                    })}
                  </GridContent>
                </>
              );
            }}
          </Grid>
        </div>
      </motion.div>
    </Section>
  );
};

export default ImageGridModule;
